/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/index.scss":
/*!************************!*\
  !*** ./src/index.scss ***!
  \************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://testing-theme/./src/index.scss?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = {};
/******/ 	__webpack_modules__["./src/index.scss"](0, __webpack_exports__, __webpack_require__);
/******/ 	
/******/ })()
;

var toAppend = document.querySelectorAll('.template--15873236730044__main .rf-content__image');

// Crea un nuevo elemento div
var newDiv = document.createElement('div');
newDiv.className = "rf-block-rrss__body template--15873236730044__rrss rf-container";

// Crea un nuevo elemento ul
var newUl = document.createElement('ul');
newUl.className = "rf-block-rrss__text style-remove--list rf-text--super";

// Crea los nuevos elementos li y a y añade el contenido deseado
var newLi1 = document.createElement('li');
var newLink1 = document.createElement('a');
newLink1.href = "https://www.facebook.com/";
newLink1.className = "link style-remove--link";
newLink1.innerHTML = '<svg width="21" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.17424 3.4512H10V0.17516C9.68561 0.130889 8.60227 0.0302734 7.34091 0.0302734C4.70833 0.0302734 2.9053 1.73671 2.9053 4.87189V7.75755H0V11.42H2.9053V20.6363H6.46591V11.42H9.25379L9.69697 7.75755H6.46591V5.23411C6.46591 4.17563 6.74242 3.4512 8.17424 3.4512V3.4512Z" fill="currentColor"></path></svg><span class="">Redflag Swimwear</span>';
newLi1.appendChild(newLink1);
newUl.appendChild(newLi1);

var newLi2 = document.createElement('li');
var newLink2 = document.createElement('a');
newLink2.href = "http://instagram.com";
newLink2.className = "link style-remove--link";
newLink2.innerHTML = '<svg width="21" height="21" aria-hidden="true" focusable="false" role="presentation" class="icon icon-instagram" viewBox="0 0 18 18"><path fill="currentColor" d="M8.77 1.58c2.34 0 2.62.01 3.54.05.86.04 1.32.18 1.63.3.41.17.7.35 1.01.66.3.3.5.6.65 1 .12.32.27.78.3 1.64.05.92.06 1.2.06 3.54s-.01 2.62-.05 3.54a4.79 4.79 0 01-.3 1.63c-.17.41-.35.7-.66 1.01-.3.3-.6.5-1.01.66-.31.12-.77.26-1.63.3-.92.04-1.2.05-3.54.05s-2.62 0-3.55-.05a4.79 4.79 0 01-1.62-.3c-.42-.16-.7-.35-1.01-.66-.31-.3-.5-.6-.66-1a4.87 4.87 0 01-.3-1.64c-.04-.92-.05-1.2-.05-3.54s0-2.62.05-3.54c.04-.86.18-1.32.3-1.63.16-.41.35-.7.66-1.01.3-.3.6-.5 1-.65.32-.12.78-.27 1.63-.3.93-.05 1.2-.06 3.55-.06zm0-1.58C6.39 0 6.09.01 5.15.05c-.93.04-1.57.2-2.13.4-.57.23-1.06.54-1.55 1.02C1 1.96.7 2.45.46 3.02c-.22.56-.37 1.2-.4 2.13C0 6.1 0 6.4 0 8.77s.01 2.68.05 3.61c.04.94.2 1.57.4 2.13.23.58.54 1.07 1.02 1.56.49.48.98.78 1.55 1.01.56.22 1.2.37 2.13.4.94.05 1.24.06 3.62.06 2.39 0 2.68-.01 3.62-.05.93-.04 1.57-.2 2.13-.41a4.27 4.27 0 001.55-1.01c.49-.49.79-.98 1.01-1.56.22-.55.37-1.19.41-2.13.04-.93.05-1.23.05-3.61 0-2.39 0-2.68-.05-3.62a6.47 6.47 0 00-.4-2.13 4.27 4.27 0 00-1.02-1.55A4.35 4.35 0 0014.52.46a6.43 6.43 0 00-2.13-.41A69 69 0 008.77 0z"></path><path fill="currentColor" d="M8.8 4a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 7.43a2.92 2.92 0 110-5.85 2.92 2.92 0 010 5.85zM13.43 5a1.05 1.05 0 100-2.1 1.05 1.05 0 000 2.1z"></path></svg><span class="">@redflagswimwear</span>';
newLi2.appendChild(newLink2);
newUl.appendChild(newLi2);

newDiv.appendChild(newUl);

// Añade el nuevo contenido dentro de toAppend
// toAppend[0].appendChild(newDiv);





